import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { isNumber } from "../utils/commonUtility";
import { currencyIdsMap, currencyTypes } from "../utils/localeData";
import { intl } from "../utils/i18nUtility";
import Currency from "./Currency";

var FormattedCurrency = function FormattedCurrency(_ref) {
  var currency = _ref.currency,
      value = _ref.value;
  if (!isNumber(value)) return 'Invalid Currency Value';

  if (typeof currency !== "string") {
    return '';
  }

  var formattedString = intl.get(currencyIdsMap.get(currency.toLowerCase()), {
    price: value
  });
  return isEmpty(formattedString) ? Currency({
    code: currency.toUpperCase(),
    value: value
  }) : formattedString;
};

FormattedCurrency.defaultProps = {
  currency: 'USD'
};
FormattedCurrency.propTypes = {
  /** value is required */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,

  /** currency type (USD,EUR,...) */
  currency: PropTypes.oneOf(currencyTypes)
};
export default FormattedCurrency;